import { Grid } from '@material-ui/core'
import { Button } from '@mui/material'

// FIXME: how to remove these dependencies to react-admin?
import { useNotify, useRefresh } from 'react-admin'

import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const MakeAllVotesButton = ({
  setIsChanged,
  resolution,
  title,
  buildApiPromise,
}) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const classes = useStyles()

  if (resolution.subs.length > 0) return null
  if (!resolution.opened) return null

  const func = () =>
    buildApiPromise()
      .then((res) => {
        setIsChanged((prev) => {
          let newVal = new Date().getTime()
          return newVal
        })

        if (res.data.votesCount == null && res.data.votesCount == undefined) {
          notify('Votre demande de votes a été prise en compte avec succès.', {
            type: 'success',
          })
        } else if (res.data.votesCount > 0) {
          notify(
            `Votre demande de votes a été prise en compte avec succès (${res.data.votesCount} votes créés).`,
            { type: 'success' }
          )
        } else {
          notify("Aucun vote n'a été créé.", { type: 'warning' })
        }

        refresh()
      })
      .catch((err) => {
        if (err.data) {
          notify(`Votes - Une erreur est survenue : ${err.data.message}`, {
            type: 'error',
          })
        } else {
          notify(
            'Votes : Une erreur est survenue. Veuillez ré-essayer plus tard.',
            { type: 'error' }
          )
        }
      })

  return (
    <Grid item xs={12}>
      <Button
        fullWidth={true}
        variant="contained"
        size="normal"
        color="secondary"
        onClick={func}
      >
        {title}
      </Button>
    </Grid>
  )
}

export default MakeAllVotesButton
